import { OktaAuth } from "@okta/okta-auth-js";
import {
  OKTA_EXTERNAL_CONFIG,
  OKTA_INTERNAL_CONFIG,
} from "./utils/appConstant";

const externalConfig = OKTA_EXTERNAL_CONFIG;

const internalConfig = OKTA_INTERNAL_CONFIG;

export const createOktaAuthForLogout = (isExternal) =>
  new OktaAuth(isExternal ? externalConfig : internalConfig);

export { externalConfig, internalConfig };
